module.exports = __webpack_public_path__ + "static/media/favorite.72ed2785.svg";